module.exports = __webpack_public_path__ + "static/media/battery.5c4b53f1.svg";